import React from 'react';
import { StyleSheet } from 'react-native';
import { rem } from 'design-system';
import Text from 'design-system/Text';
import { formatAddress, formatDateForItem } from 'utils/formatting';
import AddressVerificationStatusView from 'design-system/AddressVerificationStatusView';
const FormattedAddress = ({ townOrCity, county, postcode, uk, kycStatus, startDate, endDate, ...rest }) => {
    const line2 = React.useMemo(() => {
        const parts = [];
        if (townOrCity)
            parts.push(townOrCity);
        if (county)
            parts.push(county);
        if (uk)
            parts.push('United Kingdom');
        return parts.join(', ');
    }, [county, townOrCity, uk]);
    return (<>
      <AddressVerificationStatusView status={kycStatus}/>
      <Text Text-16>{formatAddress(rest)}</Text>
      <Text TextThin-14 Secondary>
        {line2}
      </Text>
      {!!postcode && (<Text TextThin-14 Secondary>
          {postcode}
        </Text>)}
      {!!startDate && (<Text Text-12 Gray-50 style={styles.movedInDate}>
          {formatDateForItem(startDate)} - {endDate ? formatDateForItem(endDate) : null}
        </Text>)}
    </>);
};
const styles = StyleSheet.create({
    movedInDate: {
        marginTop: rem(8),
    },
});
export default React.memo(FormattedAddress);
